import { IOnboardingStepProps } from "../Onboarding";

import { View } from "./View";

export const OnboardingSix = (props: IOnboardingStepProps) => {
  return <View onSubmit={props.handleNext} {...props} />;
};
